/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Search_TrackingInputs */

const en_orders_search_tracking = /** @type {(inputs: Orders_Search_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search tracking...`)
};

const es_orders_search_tracking = /** @type {(inputs: Orders_Search_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar tracking...`)
};

/**
* | output |
* | --- |
* | "Search tracking..." |
*
* @param {Orders_Search_TrackingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_search_tracking = /** @type {((inputs?: Orders_Search_TrackingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Search_TrackingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_search_tracking(inputs)
	return es_orders_search_tracking(inputs)
});